import NextHead from "next/head";

import { envDescription } from "../lib/formats/common";

export function Head({ title }: { title: React.ReactNode }) {
  return (
    <NextHead>
      <title>
        {title} － {envDescription()}
      </title>
    </NextHead>
  );
}
